import { Box, styled } from '@mui/material';
import React from 'react';
import { ExternalSignup } from '../../types';
import { useIntl } from 'react-intl';

const Wrapper = styled(Box)(({ theme }) => ({
  padding: '20px 0',
  textAlign: 'center',
  marginTop: '-2rem',
  color: theme.palette.common.white,
}));

type Props = {
  externalSignup: ExternalSignup;
};

const AssociationBanner: React.FC<Props> = ({ externalSignup }) => {
  const intl = useIntl();
  return (
    <Wrapper
      component="section"
      sx={{ backgroundColor: '#' + externalSignup.associationColor }}
    >
      {intl.formatMessage(
        { id: 'signup.externalLanding.associationBanner' },
        {
          logo: <img src={externalSignup.associationLogo} />,
        },
      )}
    </Wrapper>
  );
};

export default AssociationBanner;
